import React, { useState, useEffect } from "react";
import { Col, Row, Card, Form, Button } from '@themesberg/react-bootstrap';
import { useHistory } from "react-router-dom";

export const MyProfileForm = ({ user, onSubmit }) => {
  const history = useHistory();
  const [form, setForm] = useState({
    name: "",
    age: "",
    phone: "",
    email: "",
    gender: ""
  });

  useEffect(() => {
    if (user) {
      setForm({
        name: user.name || "",
        age: user.age?.toString() || "",
        gender: user.gender?.toString() || "",
        phone: user.phone || "",
        email: user.email || ""
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value, multiple, options } = e.target;

    if (multiple) {
      const selectedValues = Array.from(options)
        .filter(option => option.selected)
        .map(option => option.value);
      setForm((prev) => ({ ...prev, [name]: selectedValues }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) onSubmit(form);
  };

  return (
    <Card border="light" className="bg-white shadow-sm mb-4">
      <Card.Body>
        <h5 className="mb-4">My information</h5>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group id="name">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="name"
                  value={form.name}
                  placeholder="Enter your name"
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="age">
                <Form.Label>Age</Form.Label>
                <Form.Control
                  required
                  type="number"
                  name="age"
                  value={form.age}
                  placeholder="Enter your age"
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Form.Group id="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  disabled
                  type="email"
                  name="email"
                  value={form.email}
                  placeholder="name@company.com"
                  readOnly
                />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="gender">
                <Form.Label>Gender</Form.Label>
                <Form.Select
                  name="gender"
                  value={form.gender}
                  onChange={handleChange}
                >
                  <option value="">Gender</option>
                  <option value="2">Male</option>
                  <option value="1">Female</option>
                  <option value="3">Others</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Form.Group id="phone">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  name="phone"
                  value={form.phone}
                  placeholder="+12-345 678 910"
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="mt-3">
            <Button variant="primary" type="button" onClick={() => history.goBack()}>
              Back
            </Button>
            <Button style={{ float: "right" }} variant="primary" type="submit">
              Save All
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};
